import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    marginLeft: 0,
  },
  textField: {
    marginTop: 13,
  },
  marginDefault: {
    margin: theme.spacing(0),
  },
  marginText: {
    fontSize: 12, marginTop: 4, marginLeft: theme.spacing(1),
  },
  typo: {
    color: theme.palette.text.hint,
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active': {
      boxShadow: theme.customShadows.widgetWide,
    },
  },
}));
